//@author: devin

import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { S25EditableAbstract } from "../s25.editable.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-editable-number")
@Component({
    selector: "s25-ng-editable-number",
    template: `
        @if (this.readOnly()) {
            <span>{{ this.val }}</span>
        } @else {
            <div>
                @if (!this.editing) {
                    <button
                        type="button"
                        class="s25-editable-shared-container c-editable-text editable editable-click"
                        [id]="fieldId()"
                        (click)="this.editMode()"
                        [attr.aria-labelledby]="ariaLabelledBy()"
                        [attr.aria-label]="ariaLabelText() || 'Editable Number'"
                    >
                        <div class="s25-editable s25-data">{{ this.val }}</div>
                    </button>
                }
                @if (this.editing) {
                    <div>
                        <input
                            class="firstFocusEditable c-input"
                            type="number"
                            [id]="fieldId()"
                            [attr.aria-labelledby]="ariaLabelledBy()"
                            [attr.aria-label]="ariaLabelText()"
                            [min]="this.min()"
                            [max]="this.max()"
                            [disabled]="this.disabled()"
                            step="1"
                            [ngModel]="this.candidateVal"
                            (ngModelChange)="this.update($event)"
                            (blur)="this.onInputBlur()"
                            (keyup.enter)="this.submit()"
                        />
                        @if (hasCancelButton || hasCommitButton) {
                            <div class="aw-button-group">
                                @if (hasCancelButton) {
                                    <button
                                        class="aw-button aw-button--outline"
                                        (click)="this.cancel()"
                                        (keyup.enter)="this.cancel()"
                                    >
                                        {{ this.cancelButtonText }}
                                    </button>
                                }
                                @if (hasCommitButton) {
                                    <button
                                        class="aw-button aw-button--primary"
                                        (click)="this.commit()"
                                        (keyup.enter)="this.commit()"
                                    >
                                        {{ this.commitButtonText }}
                                    </button>
                                }
                            </div>
                        }
                        @if (this.errorMessages) {
                            <div>
                                @for (msg of this.errorMessages; track msg) {
                                    <div class="ngRed ngBold">
                                        {{ msg }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    `,
    host: {
        "[class.editing]": "editing",
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableNumberComponent extends S25EditableAbstract<number> implements OnInit {
    @Input() type: "integer" | "float" = "integer";

    getType = () => {
        return this.type;
    };

    ngOnInit() {
        super.ngOnInit();
    }
}
